import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

import { PromotionContentsResponse } from '~/routes/api+/external+/promotion-contents';

export const usePromotionContents = ({
  promotionCodes,
  channel,
}: {
  promotionCodes: string[];
  channel: string | null;
}) => {
  const { data } = useQuery({
    queryKey: ['promotion-contents', channel, promotionCodes],
    queryFn: async () => {
      const { data } = await axios.get<PromotionContentsResponse['promotions']>(
        `/api/external/promotion-contents?channel=${channel}&promotionCodes=${promotionCodes.join()}`,
      );
      return data[0] || null;
    },
    enabled: promotionCodes.length > 0,
  });

  return {
    data,
  };
};
